import Model, { attr, belongsTo } from '@ember-data/model';
import type { ReportSource } from 'garaje/models/approval-status';
import type { BaseReport } from 'garaje/models/screener-result';
import { withScreenerTypeGuards } from 'garaje/models/screener-result';
import type VisitApproval from 'garaje/models/visit-approval';
import { idScanningHoldTileMessage } from 'garaje/utils/id-scanning-hold-copy';
import { equal } from 'macro-decorators';

export default class ScreenerReview extends withScreenerTypeGuards(Model) {
  @attr('string') declare screenerSource: ReportSource;
  @attr('date') declare reviewedAt: Date;
  @attr('string') declare reviewerName: string;
  @attr('string') declare action: 'approve' | 'deny';

  @attr('immutable') declare report: BaseReport;

  @equal('action', 'approve') declare isApproved: boolean;
  @equal('action', 'deny') declare isDenied: boolean;

  @belongsTo('visit-approval', { async: false, inverse: 'screenerReviews' }) declare visitApproval: VisitApproval;

  get idScanningFailureMessage(): string {
    if (!this.isIdScanning()) return '';
    return idScanningHoldTileMessage(this.report);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'screener-review': ScreenerReview;
  }
}
